var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0469 12L14.875 7.21875L15.8594 6.23438C16 6.09375 16 5.85938 15.8594 5.67188L14.8281 4.64062C14.6406 4.5 14.4062 4.5 14.2656 4.64062L8.5 10.4531L2.6875 4.64062C2.54688 4.5 2.3125 4.5 2.125 4.64062L1.09375 5.67188C0.953125 5.85938 0.953125 6.09375 1.09375 6.23438L6.90625 12L1.09375 17.8125C0.953125 17.9531 0.953125 18.1875 1.09375 18.375L2.125 19.4062C2.3125 19.5469 2.54688 19.5469 2.6875 19.4062L8.5 13.5938L13.2812 18.4219L14.2656 19.4062C14.4062 19.5469 14.6406 19.5469 14.8281 19.4062L15.8594 18.375C16 18.1875 16 17.9531 15.8594 17.8125L10.0469 12Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6623e86b.svg";
export { ForwardRef as ReactComponent };